import { axiosGet } from './axiosService';
const basePaymentURL = '/payments';

export class PaymentService {
	getPaymentSchedule(loanId) {
		return axiosGet(null, basePaymentURL + `/me/${loanId}`);
	}

	getPaymentScheduleById(loanId) {
		return axiosGet(null, basePaymentURL + `/${loanId}`);
	}
}
